export default defineNuxtPlugin(() => {
	const { loadScript } = useScriptLoader()
	if (import.meta.client) {
		const link = document.createElement('link')
		link.rel = 'stylesheet'
		link.href = '/font/lazy.fonts.css'
		document.head.appendChild(link)

		// Load Script
		if (!import.meta.env.DEV) {
			loadScript('/js/google.js')
		}
	}
})
